module.exports = __webpack_public_path__ + "assets/f24a8fc31e0d21690772365b36b769fc.mp3";